module.exports = __webpack_public_path__ + "img/9791195474219.1f52a397.jpg";